import { useSelector } from 'react-redux'

import { statisticsSelector } from 'features/organization_statistics'

import {
  useFetchUsersVideoConferencingIntegrationsReport,
  useFetchUsersCalendarIntegrationsReport
} from '../api'
import { REPORT_STATUS, COLLECTION_NAME } from '../constants'

/**
 * @returns {boolean} returns true when all fetched data was successful every count was 0
 */
export const useCheckForTeamSetUpEmptyData = () => {
  const notConnectedUserVideoIntegrations = useFetchUsersVideoConferencingIntegrationsReport(
    { group_by: COLLECTION_NAME.USER, status: REPORT_STATUS.NOT_CONNECTED }
  )

  const failedUserVideoIntegrations = useFetchUsersVideoConferencingIntegrationsReport(
    { group_by: COLLECTION_NAME.USER, status: REPORT_STATUS.HAS_ERRORS }
  )

  const notConnectedUserIntegrationsData = useFetchUsersCalendarIntegrationsReport(
    { group_by: COLLECTION_NAME.USER, status: REPORT_STATUS.NOT_CONNECTED }
  )

  const failedUserIntegrationsData = useFetchUsersCalendarIntegrationsReport(
    { group_by: COLLECTION_NAME.USER, status: REPORT_STATUS.HAS_ERRORS }
  )

  const { invitations, isInvitationsLoading } = useSelector(statisticsSelector)

  const invitationsEmpty = (invitations === 0 && !isInvitationsLoading)

  return [
    notConnectedUserVideoIntegrations,
    failedUserVideoIntegrations,
    notConnectedUserIntegrationsData,
    failedUserIntegrationsData
  ].map(({ data = {}, isSuccess, isFetching } = {}) => (
    isFetching ? false : (isSuccess && data.count === 0))
  ).every(Boolean) && invitationsEmpty
}
